export enum CustomerType {
	Final = 0,
	Delivery = 1,
}
